var crSavePickupProperties = true;
var CRskipUpdateFormAction = true;
//var crBeacon = true; // disabled on Sep 6th as it might the one causing the missing information
if (typeof stores !== 'undefined') {
  for (var i = 0; i < stores.length; i++) {
        if (!stores[i]) continue;

        var storeName = stores[i].name.toLowerCase();
        var storeId = stores[i].storeID;

    //Metairie+Gretna exclude Belle Chasse   
    if (specialProduct4 === true) {
          if (storeId === 7799  ) {
            delete stores[i];
          }         
    } else
      
      // Metairie+Belle Chasse exclude Gretna
    if (specialProduct5 === true) {
          if (storeId === 8239 ) {
            delete stores[i];
          }         
    } else 
    //Belle Chasse+Gretna exclude Metairie
    if (specialProduct6 === true) {
          if (storeId === 2800) {
            delete stores[i];
          }         
    } else 
      
        if (specialProduct === true) {
          if (storeId === 2800  || storeId === 8239 || storeId === 3762 ) {
            delete stores[i];
          }         
        } else

        if (specialProduct2 === true) {          
          if (storeId === 2800  || storeId === 7799 || storeId === 3762  ) {
            delete stores[i];
          }         
        } else

       if (specialProduct3 === true) {
          if (storeId === 8239   || storeId === 7799 || storeId === 3762  ) {
            delete stores[i];
          }         
        }

        if (specialProduct7 === true) {
          if (storeId === 8239   || storeId === 7799 || storeId === 2800 ) {
            delete stores[i];
          }         
        }

  }
}
document.addEventListener('crPickupActivated', function (e) { 
  console.log('*** Activated ***');

  if (
    (specialProduct === true && specialProduct2 === true) ||
    (specialProduct === true && specialProduct3 === true) ||
    (specialProduct === true && specialProduct4 === true) ||
    (specialProduct === true && specialProduct5 === true) ||
    (specialProduct === true && specialProduct6 === true) ||
    (specialProduct === true && specialProduct7 === true) ||
    
    (specialProduct2 === true && specialProduct3 === true) ||
    (specialProduct2 === true && specialProduct4 === true) ||
    (specialProduct2 === true && specialProduct5 === true) ||
    (specialProduct2 === true && specialProduct6 === true) ||
    (specialProduct2 === true && specialProduct7 === true) ||
    
    (specialProduct3 === true && specialProduct4 === true) ||
    (specialProduct3 === true && specialProduct5 === true) ||
    (specialProduct3 === true && specialProduct6 === true) ||
    (specialProduct3 === true && specialProduct7 === true) ||
    
    (specialProduct4 === true && specialProduct5 === true) ||
    (specialProduct4 === true && specialProduct6 === true) ||
    (specialProduct4 === true && specialProduct7 === true) ||
    
    (specialProduct5 === true && specialProduct6 === true) ||
    (specialProduct5 === true && specialProduct7 === true) ||
    
    (specialProduct6 === true && specialProduct7 === true) 
   ) {
    console.log('disable');
    disableCheckoutButton2();
  	var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
	setTimeout(function() { clearInterval(tt); }, 7000);  
	jqCR('#cr-error').html('Your order contains products from multiple locations, for that reason you can not choose this option.')
    jqCR('#pickup-details').remove()
    }
});




function activateCheckoutButton2(){    
    document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}



//////////
// continuosly check if the fields are completed
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
  
    disableCheckoutButton2();
    var tt = setInterval(function(){
      disableCheckoutButton2();
      //console.log('check.............')
      var fieldsCorrect = checkPickupFields();
      //console.log({fieldsCorrect})
      if (fieldsCorrect === true) {
        //clearInterval(tt);  
      }
      
    }, 1000);
    //setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  trackChange(jqCR("#pickup-selected-store")[0] );  

  //jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
  //trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer?.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var email = jqCR('#pickup-email').val();    
    var extra1 = jqCR('#extra_input_1').val();
    var extra2 = jqCR('#extra_input_2').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (selectedStoreId && extra1 && extra2) {
      activateCheckoutButton2();
      return true;
    }
    disableCheckoutButton2()
    return false;
}

function activateCheckoutButton2(){
  //console.log('Activate')
      document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}